import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Nav.css";

export default function Nav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  // Helper: returns 'active' class if this path is current
  const active = (path) => (pathname === path ? "active" : "");

  function goToSection(sectionId) {
    if (pathname === "/") {
      // Already on home — just scroll
      document
        .getElementById(sectionId)
        ?.scrollIntoView({ behavior: "smooth" });
    } else {
      // Navigate home first, then scroll after the page renders
      navigate("/");
      setTimeout(() => {
        document
          .getElementById(sectionId)
          ?.scrollIntoView({ behavior: "smooth" });
      }, 100); // small delay lets the home page mount first
    }
  }

  return (
    <nav className="main-nav">
      <Link to="/" className="nav-logo">
        JR<span>.</span>
      </Link>
      <ul className="nav-links">
        <li>
          <Link to="/skills" className={active("/skills")}>
            Skills
          </Link>
        </li>
        <li>
          <Link to="/projects" className={active("/projects")}>
            Projects
          </Link>
        </li>
        <li>
          <Link to="/experience" className={active("/experience")}>
            Experience
          </Link>
        </li>
        <li>
          <Link to="/devlog" className={active("/devlog")}>
            Devlog
          </Link>
        </li>
        <li>
          <button onClick={() => goToSection("contact")}>Contact</button>
        </li>
      </ul>
    </nav>
  );
}
